import FJConstant from '../../constants/FJConstant';
import FJUtil from '../../util/FJUtil';
import { FJVideoRemoveAfterManage } from './FJVideoRemoveAfterManage';

class FJVideoRemoveAutoManage extends FJVideoRemoveAfterManage {
    constructor() {
        super();
    }

    /**
     * @desc 设置视频源
     */
    async setSource(src) {
        try {
            const video = document.createElement('video');
            video.crossOrigin = 'anonymous';
            this._loadStatus = FJConstant.LOADING;

            this._sourceUrl = src;
            // 解决缓存问题
            let videoBlob = await FJUtil.getBlobByUrl(src);
            if (!videoBlob) {
                videoBlob = await FJUtil.getBlobByUrl(src + '?v=' + Date.now());
            }

            if (!videoBlob) {
                throw new Error('Failed to load video');
            }

            const blobUrl = URL.createObjectURL(videoBlob);

            const sourceInfo = await new Promise((resolve, reject) => {
                video.oncanplay = () => {
                    const fileData = {
                        width: video.videoWidth,
                        height: video.videoHeight,
                    };
                    this._duration = video.duration;

                    this._loadStatus = FJConstant.SUCCESS;
                    resolve(fileData);
                };
                video.onerror = () => {
                    this._loadStatus = FJConstant.ERROR;
                    reject();
                };

                video.src = blobUrl;
            });

            this._source = video;
            this._sourceInfo = sourceInfo;

            const file = new File([videoBlob], 'video.webm', { type: 'video/webm' });
            this._sourceFile = file;

            this.updateBackgroundCanvas();
        } catch (error) {
            this._loadStatus = FJConstant.ERROR;
            throw error;
        }
    }
}

const FJVideoRemoveAutoManageSingleton = new FJVideoRemoveAutoManage();
export default FJVideoRemoveAutoManageSingleton;
